import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Masonry from 'react-masonry-component';
import { css, withStyles } from '../../assets/styles/withStyles';
import Project from '../../components/project';
import { loadWorks } from '../../redux/actions/works';
import { getOrderedWorks, moreWorksToGet } from '../../redux/selectors/works';

class Feed extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      workHeight: 0
    };

    this._onScroll = this._onScroll.bind(this);
    this._calcHeight = this._calcHeight.bind(this);
  }

  componentDidMount() {
    this.props.loadWorks(true, null, { sort: 'num' });

    this._list.addEventListener('scroll', this._onScroll, false);
  }

  componentWillUnmount() {
    this._list.removeEventListener('scroll', this._onScroll, false);
  }

  _onScroll(event) {
    if (
      event.target.scrollTop + this._list.getBoundingClientRect().height + 200 >
      this.state.workHeight
    ) {
      if (!this.props.isLoading && this.props.moreWorksToGet) {
        this.props.loadWorks(false, null, { sort: 'num' });
      }
    }
  }

  _calcHeight(event) {
    if (event.length > 0)
      this.setState({
        workHeight: event[0].layout.size.height
      });
  }

  render() {
    const { styles, works } = this.props;

    return (
      <div ref={list => (this._list = list)} {...css(styles.container)}>
        <Masonry
          onLayoutComplete={this._calcHeight}
          options={{
            transitionDuration: 0,
            columnWidth: 1,
            gutter: 0
          }}
        >
          {works.map(work => (
            <Project key={work.slug} id={work.slug} />
          ))}
        </Masonry>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  works: getOrderedWorks(state),
  isLoading: state.works.isLoading,
  moreWorksToGet: moreWorksToGet(state)
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      loadWorks
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withStyles(({ breakpoints }) => ({
    container: {
      paddingTop: 76,
      position: 'fixed',
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
      overflow: 'scroll',

      [breakpoints.md]: {
        paddingTop: 0,
        left: '33%'
      }
    }
  }))(Feed)
);



// WEBPACK FOOTER //
// ./src/containers/Feed/index.js